<template>
    <div class="modal fade" :id="'createStepModal_'+id" data-backdrop="static" tabindex="-2" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ !isEdit ? $t('crm-setting.pipeline.step.creation') : $t('crm-setting.pipeline.step.modification') }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">

                        <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" :href="'#kt_info'+id">{{ $t("crm-setting.pipeline.step.info") }}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" :href="'#kt_criterias'+id">{{ $t("crm-setting.pipeline.step.criterias") }}</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" :id="'kt_info'+id" role="tabpanel">
                                <RequiredText />
                                <Input
                                    containerClass="col-12 mt-2 mb-5"
                                    :name="`${id}-name`"
                                    type="text"
                                    :label="$t('crm-setting.pipeline.step.name')"
                                    labelClass="form-label"
                                    :inputClass="'form-control form-control-lg form-control-solid'"
                                    :placeholder="$t('crm-setting.pipeline.step.name')"
                                    :isRequired="true" size="lg"
                                    v-model="formData.name"
                                />
                                <div v-if="!isEdit">
                                    <Input
                                        containerClass="col-12 mt-2 mb-5"
                                        :name="`${id}-closure_rate`"
                                        type="number"
                                        min="1"
                                        :label="$t('crm-setting.pipeline.step.closure_rate')"
                                        labelClass="form-label"
                                        :inputClass="'form-control form-control-lg form-control-solid'"
                                        :isRequired="false" size="lg"
                                        v-model="formData.closure_rate"
                                    />
                                </div>
                            </div>
                            <div class="tab-pane fade " :id="'kt_criterias'+id" role="tabpanel">
                                <br>
                               
                                <div class="d-flex align-items-center justify-content-center mb-4" v-for="(item, index) in formData.criterias" :key="index">
                                    <Input
                                        containerClass="col-11 me-3"
                                        :name="`${id}-name`"
                                        type="text"
                                        label=""
                                        labelClass="form-label"
                                        :inputClass="'form-control form-control-lg form-control-solid'"
                                        :placeholder="$t('crm-setting.pipeline.step.criteria')"
                                        :isRequired="true"
                                        v-model="item.title"
                                    />
                                    <button @click="removeField(index)" class="btn btn-sm btn-icon btn-light-danger">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>
                                <div class="mt-2" v-if="isEdit && formData.criterias?.length > 0">
                                    <SwitchInput :label="$t('crm-setting.pipeline.step.apply_to_older')" v-model="formData.apply_to_older" :between="true"/>
                                </div>
                                <div class="d-flex flex-row-reverse mt-3">
                                    <Button btn-class="btn-sm " type="new" @click="addField" btn-text="crm-setting.pipeline.step.add_field" />
                                </div>
                                <br>
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingStep"></Button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
    import {ref, defineProps} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Input from "@/components/Input.vue";
    import Button from "@/components/Button.vue"
    import OutlineButton from "@/components/OutlineButton.vue"
import SwitchInput from '@/components/SwitchInput.vue';

    const store = useStore()

    const props = defineProps({
        step: { 
            type: Object, 
            default: {
                name: '',
                closure_rate: 0,
                criterias: [],
                apply_to_older: true
            } 
        },
        id: {
            type: String,
            required: true
        },
        parent: {
            type: String,
            required: false
        },
        isEdit: {
            type: Boolean,
            required: false
        }
    })

    const emits = defineEmits(['load', 'addStep'])
  
    const criteria = ref('')
    const formData = ref(props.step)
    const isLoadingStep = ref(false)

    function submitData(){
        if(!props.isEdit){
            createStepData()
        }else{
            updateStepData()
        }
    } 

    function addField(){
        formData.value.criterias.push({id: null, title: ''})
    }

    function removeField(fieldIndex){
        let data = formData.value.criterias
        data.splice(fieldIndex, 1)
        formData.value.criterias = data    
    }

    function closeModal(){
        if(props.parent){
            $('#'+props.parent).modal('toggle')
        }
        $('#createStepModal_'+props.id).modal('toggle')
    }

    function createStepData(){
        isLoadingStep.value = true
        store.dispatch('steps/createStep', formData.value)
            .then((response) => {
                emits('addStep', response.data?.id)
                emits('load')
                isLoadingStep.value = false
                closeModal()
                formData.value.name = ''
                formData.value.closure_rate = 0
                formData.value.criterias = []
                window.toastr['success'](i18n.global.t('notification.step_created'))
            })
            .catch(err => {
                isLoadingStep.value = false
            })
    }

    function updateStepData(){
        isLoadingStep.value = true
        
        store.dispatch('steps/updateStepName', formData.value)
            .then((response) => {
                emits('load')
                isLoadingStep.value = false
                closeModal()
                formData.value.id = ''
                formData.value.name = ''
                formData.value.closure_rate = 0
                formData.value.criterias = []
                window.toastr['success'](i18n.global.t('notification.step_updated'))
            })
            .catch(err => {
                isLoadingStep.value = false
            })
    }
</script>